import { Model } from 'infra/model'
import { observable, makeObservable } from 'mobx'
import { PermissionSet } from '../dtos/permissions'
import { RoleDTO } from 'iam/dtos/role'
import { Id } from 'types/definitions'
import { DateZero, maybeParseDate } from '../../utils/date-util'

export default class Role extends Model<RoleDTO, Role> {
  @observable id = Id.none
  @observable name = ''
  @observable description = ''
  @observable permissions: PermissionSet = {}
  @observable workspaceId = Id.none
  @observable isOwnerRole = false
  @observable dateCreated = DateZero()
  @observable dateModified = DateZero()

  constructor() {
    super()

    makeObservable(this)
  }

  parse(attrs: Partial<RoleDTO>): Partial<Role> {
    return {
      id: attrs.id,
      name: attrs.name,
      isOwnerRole: attrs.is_owner_role,
      description: attrs.description,
      permissions: attrs.permissions,
      workspaceId: attrs.workspace_id,
      dateCreated: maybeParseDate(attrs.date_created),
      dateModified: maybeParseDate(attrs.date_modified),
    }
  }

  toJSON(): RoleDTO {
    return {
      id: this.id || '',
      description: this.description,
      is_owner_role: this.isOwnerRole,
      name: this.name,
      permissions: this.permissions,
      workspace_id: this.workspaceId || '',
      date_created: this.dateCreated.toISOString(),
      date_modified: this.dateModified.toISOString(),
    }
  }
}
